//----------------------------------------------------
// Project js file
//----------------------------------------------------

// bootstrap import
// import "bootstrap"
import loader from './parts/loader.js'
import navigation from './parts/navigation.js'
import Smooth from './parts/Smooth.js'
import VideoModal from './parts/VideoModal.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

loader()
// navigation()
// smooth()
console.log('Hello world!')

// ----------------------------------------------------
// 内部リンク
// ----------------------------------------------------
const smooth = new Smooth({
  linkTarget: '.h-menu__nav a[href*="#"]',
  breakPoint: 768, // px
  pcWaitTime: 500, // ms
  spWaitTime: 500, // ms
  beforeChange: () => {
    document.getElementById('h-menu').classList.remove('h-menu--open')
    document.getElementById('header__ham').classList.remove('header__ham--open')
    document.querySelectorAll('.h-click__before.sns__list').forEach((elm) => {
      elm.classList.remove('sns__list--open')
    })
    document
      .getElementById('header__contact')
      .classList.remove('header__contact--open')
  },
  exceptionId: ['exceptionId'], // 例外用のID
  exceptionFn: (id) => {
    // 例外処理
  }
})

//----------------------------------------------------
// 3連サイネージページ スクロールアニメーション
//----------------------------------------------------
const signVisionContainer = document.getElementById(
  'page3SignVisionAbout_container'
)
if (signVisionContainer) {
  // gsap animation (timeline) ver.3.0.0
  // -------------------------------------------------
  let timeLine
  let sizeMobile = false
  const winHeight = window.outerHeight
  const scrollTextHeight = (name) => {
    const elm = document.querySelector(name)
    const elmHeight = elm.offsetHeight
    const val = Math.ceil(winHeight + elmHeight)
    return val
  }
  const setTimeline = () => {
    sizeMobile = false
    timeLine = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.page3SignVisionAbout_container',
          start: 'top top',
          end: '+=14000',
          pin: true,
          pinSpacing: true,
          scrub: 1.5
          // markers: true
        }
      })
      .set('.page3SignVisionAbout_anime-monitor.monitorLeft', {
        y: '-50%',
        autoAlpha: 0
      })
      .set('.page3SignVisionAbout_anime-monitor.monitorRight', {
        y: '-50%',
        autoAlpha: 0
      })
      .set('.page3SignVisionAbout_anime-bg', { autoAlpha: 0 })
      .set('.page3SignVisionAbout_list', { autoAlpha: 0 })
      .set('.page3SignVisionAbout_anime-monitor-fullImg', { autoAlpha: 0 })
      .set('.page3SignVisionAbout_anime-monitor-img2', {
        autoAlpha: 0,
        scale: 1.75,
        rotate: '30deg'
      })
      .set('.page3SignVisionAbout_anime-monitor-img', { autoAlpha: 0 })
      .to('.page3SignVisionAbout_anime-monitor.monitorLeft', {
        autoAlpha: 1,
        y: '+=50%',
        duration: 3,
        // ease: "bounce.out",
        ease: 'power4.out'
      })
      .to('.page3SignVisionAbout_anime-monitor.monitorRight', {
        autoAlpha: 1,
        y: '+=50%',
        duration: 3,
        delay: -1,
        // ease: "bounce.out",
        ease: 'power4.out'
      })
      .to('.page3SignVisionAbout_container', {
        // backgroundColor: "rgb(23 37 62, 0.95)", // 親要素の背景色の変更
        backgroundColor: '#253249',
        duration: 2,
        delay: -3
      })
      .to('.page3SignVisionAbout_container_bg', {
        // backgroundColor: "rgb(23 37 62, 0.95)", // 親要素の背景色の変更
        opacity: 1.0,
        duration: 2,
        delay: -3
      })
      .to('.page3SignVisionAbout_list.first', {
        autoAlpha: 1, // テキスト表示
        duration: 2,
        delay: 2.0,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-bg.first', {
        autoAlpha: 1, // BGテキストの表示
        duration: 5,
        delay: -5,
        ease: 'power2.out'
      })
      .to('.page3SignVisionAbout_list.first', {
        autoAlpha: 0, // テキスト非表示
        duration: 2,
        delay: 6,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-bg.first', {
        autoAlpha: 0, // BGテキストの非表示
        duration: 2,
        delay: -1,
        ease: 'power3.out'
      })
      .set('.page3SignVisionAbout_anime-monitor-fullImg', {
        autoAlpha: 1
      })
      .to('.page3SignVisionAbout_anime-monitor-img', {
        autoAlpha: 1,
        duration: 1,
        delay: 2.5
      })
      .set('.page3SignVisionAbout_anime-monitor', {
        backgroundColor: 'transparent'
      })
      .to('.page3SignVisionAbout_anime-monitor-img', {
        autoAlpha: 0,
        scale: 1.5,
        duration: 3,
        delay: 2.0,
        ease: 'power1.out'
      })
      .to('.page3SignVisionAbout_list.second', {
        autoAlpha: 1, // テキスト表示
        duration: 2,
        delay: 1,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-bg.second', {
        autoAlpha: 1, // BGテキストの表示
        duration: 5,
        delay: -5,
        ease: 'power2.out'
      })
      .to('.page3SignVisionAbout_list.second', {
        autoAlpha: 0, // テキスト非表示
        duration: 2,
        delay: 6,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-bg.second', {
        autoAlpha: 0, // BGテキストの非表示
        duration: 2,
        delay: -1,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-monitor-img2.monitorLeft', {
        autoAlpha: 1,
        scale: 1.0,
        rotate: 0,
        duration: 2,
        delay: 2.5
      })
      .to('.page3SignVisionAbout_anime-monitor-img2.monitorCenter', {
        autoAlpha: 1,
        scale: 1.0,
        rotate: 0,
        duration: 2,
        delay: -1
      })
      .to('.page3SignVisionAbout_anime-monitor-img2.monitorRight', {
        autoAlpha: 1,
        scale: 1.0,
        rotate: 0,
        duration: 2,
        delay: -1
      })
      .to('.page3SignVisionAbout_list.three', {
        autoAlpha: 1, // テキスト表示
        duration: 2,
        delay: 1,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-bg.three', {
        autoAlpha: 1, // BGテキストの表示
        duration: 5,
        delay: -5,
        ease: 'power2.out'
      })
      .to('.page3SignVisionAbout_list.three', {
        autoAlpha: 0, // テキスト非表示
        duration: 2,
        delay: 6,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-bg.three', {
        autoAlpha: 0, // BGテキストの非表示
        duration: 2,
        delay: -1,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-block', {
        duration: 1
      })
  }
  const setTimelineSp = () => {
    // test
    const elm = document.querySelector('.page3SignVisionAbout_list.first')
    const h = elm.outerHeight
    console.log('elmH', h)

    sizeMobile = true
    timeLine = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.page3SignVisionAbout_container',
          start: 'top top',
          end: '+=14000',
          pin: true,
          pinSpacing: true,
          scrub: 1.5
          // markers: true
        }
      })
      .set('.page3SignVisionAbout_anime-monitor.monitorLeft', {
        y: '-50%',
        autoAlpha: 0
      })
      .set('.page3SignVisionAbout_anime-monitor.monitorRight', {
        y: '-50%',
        autoAlpha: 0
      })
      .set('.page3SignVisionAbout_anime-bg', { autoAlpha: 0 })
      .set('.page3SignVisionAbout_list', { y: '100%' })
      .set('.page3SignVisionAbout_anime-monitor-fullImg', { autoAlpha: 0 })
      .set('.page3SignVisionAbout_anime-monitor-img2', {
        autoAlpha: 0,
        scale: 1.75,
        rotate: '30deg'
      })
      .set('.page3SignVisionAbout_anime-monitor-img', { autoAlpha: 0 })
      .to('.page3SignVisionAbout_anime-monitor.monitorLeft', {
        autoAlpha: 1,
        y: '+=50%',
        duration: 3,
        // ease: "bounce.out",
        ease: 'power4.out'
      })
      .to('.page3SignVisionAbout_anime-monitor.monitorRight', {
        autoAlpha: 1,
        y: '+=50%',
        duration: 3,
        delay: -1,
        // ease: "bounce.out",
        ease: 'power4.out'
      })
      .to('.page3SignVisionAbout_container', {
        // backgroundColor: "rgb(23 37 62, 0.95)", // 親要素の背景色の変更
        backgroundColor: '#253249',
        duration: 2,
        delay: -3
      })
      .to('.page3SignVisionAbout_container_bg', {
        // backgroundColor: "rgb(23 37 62, 0.95)", // 親要素の背景色の変更
        opacity: 1.0,
        duration: 2,
        delay: -3
      })
      .to('.page3SignVisionAbout_list.first', {
        y: () => -scrollTextHeight('.page3SignVisionAbout_list.first'), // テキスト表示
        duration: 12,
        delay: 2.0,
        ease: 'none'
      })
      .to('.page3SignVisionAbout_anime-bg.first', {
        autoAlpha: 1, // BGテキストの表示
        duration: 5,
        delay: -15,
        ease: 'power2.out'
      })
      .to('.page3SignVisionAbout_anime-bg.first', {
        autoAlpha: 0, // BGテキストの非表示
        duration: 2,
        delay: 1,
        ease: 'power3.out'
      })
      .set('.page3SignVisionAbout_anime-monitor-fullImg', {
        autoAlpha: 1
      })
      .to('.page3SignVisionAbout_anime-monitor-img', {
        autoAlpha: 1,
        duration: 1,
        delay: 2.5
      })
      .set('.page3SignVisionAbout_anime-monitor', {
        backgroundColor: 'transparent'
      })
      .to('.page3SignVisionAbout_anime-monitor-img', {
        autoAlpha: 0,
        scale: 1.5,
        duration: 3,
        delay: 2.0,
        ease: 'power1.out'
      })
      .to('.page3SignVisionAbout_list.second', {
        y: () => -scrollTextHeight('.page3SignVisionAbout_list.second'), // テキスト表示
        duration: 12,
        delay: 1,
        ease: 'none'
      })
      .to('.page3SignVisionAbout_anime-bg.second', {
        autoAlpha: 1, // BGテキストの表示
        duration: 5,
        delay: -15,
        ease: 'power2.out'
      })
      .to('.page3SignVisionAbout_anime-bg.second', {
        autoAlpha: 0, // BGテキストの非表示
        duration: 2,
        delay: 1,
        ease: 'power3.out'
      })
      .to('.page3SignVisionAbout_anime-monitor-img2.monitorLeft', {
        autoAlpha: 1,
        scale: 1.0,
        rotate: 0,
        duration: 2,
        delay: 2.5
      })
      .to('.page3SignVisionAbout_anime-monitor-img2.monitorCenter', {
        autoAlpha: 1,
        scale: 1.0,
        rotate: 0,
        duration: 2,
        delay: -1
      })
      .to('.page3SignVisionAbout_anime-monitor-img2.monitorRight', {
        autoAlpha: 1,
        scale: 1.0,
        rotate: 0,
        duration: 2,
        delay: -1
      })
      .to('.page3SignVisionAbout_list.three', {
        y: () => -scrollTextHeight('.page3SignVisionAbout_list.three'), // テキスト表示
        duration: 12,
        delay: 1,
        ease: 'none'
      })
      .to('.page3SignVisionAbout_anime-bg.three', {
        autoAlpha: 1, // BGテキストの表示
        duration: 5,
        delay: -15,
        ease: 'power2.out'
      })
      .to('.page3SignVisionAbout_anime-bg.three', {
        autoAlpha: 0, // BGテキストの非表示
        duration: 2,
        delay: -1,
        ease: 'power3.out'
      })
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.innerWidth >= 768 ? setTimeline() : setTimelineSp()

    // 内部リンクがあった場合の処理
    setTimeout(() => {
      const hash = location.hash
      if (hash) {
        const linkSection = document.querySelector(hash)
        const clientRect = linkSection.getBoundingClientRect()
        const scrollPosition = window.scrollY + clientRect.top
        window.scrollTo({
          top: scrollPosition,
          behavior: 'instant'
        })
      }
    }, 1000)
  })

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 768 && sizeMobile) {
      window.location.reload()
    } else if (window.innerWidth < 768 && !sizeMobile) {
      window.location.reload()
    }
  })
}

//----------------------------------------------------
// 3連サイネージページ ポップアップ動画表示
//----------------------------------------------------
const sv3ModalVideoParent = document.querySelector(
  '.page3SignVisionCase_wrapper'
)
if (sv3ModalVideoParent) {
  const videoModal = new VideoModal({
    parent: sv3ModalVideoParent,
    className: 'page3SignVisionCase_list'
  })
}
